import React, { useState } from 'react';

export default function ReleasesSection() {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  // Helper function to generate clickable list items
  const createClickableListItem = (text, imagePath) => (
    <li>• <span 
      className="text-purple-300 hover:text-purple-200 cursor-pointer underline hover:no-underline transition-all"
      onClick={() => openModal(`/images${imagePath}`)}
    >
      {text}
    </span></li>
  );

  // Helper function to generate thumbnail elements
  const createThumbnail = (imagePath, altText, otherText) => (
    <div 
      className="inline-block cursor-pointer hover:opacity-80 transition-opacity"
      onClick={() => openModal(`/images${imagePath}`)}
    >
      <img 
        src={`/images${imagePath}`} 
        alt={altText} 
        className="w-32 h-20 object-cover rounded-lg border border-purple-500/30 hover:border-purple-500/60 transition-colors"
      />
      {otherText === undefined ? <p className="text-xs text-gray-400 mt-1 text-center">Click to enlarge</p> : <p className="text-xs text-gray-400 mt-1 text-center">{otherText}</p>}
    </div>
  );
  return (
    <div className="py-20 bg-black/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">Release Notes</h2>
          <p className="text-xl text-gray-300">Stay updated with the latest Poppy Poker features</p>
        </div>
        
        <div className="space-y-8">
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.8.0</h3>
                <span className="text-sm text-gray-400">8th December 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">We think you're going to love this one!</h4>
            <p className="text-gray-300 mb-4">Here's what's new:</p>
            <p className="text-gray-300 mb-4">All venue members will now receive a notification 6 hours before a game is scheduled to start or a one off game is scheduled to start. The members can then respond to the notification and let everyone belonging to the venue know if they are going to attend the game.</p>
            <p className="text-gray-300 mb-4">The backend clock management engine has been rewritten for improved performance to cater for large number of games</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              <li>• 6 hours before games start members will receive a notification to let them know the game is about to start</li>
              {createClickableListItem('Members can respond to the notification and let everyone belonging to the venue know if they are going to attend the game', '/v1.8.0/attendance1.png')}
              <li>• The backend clock management engine has been rewritten!</li>
              <li>• Some minor frontend enhancements</li>
            </ul>
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.8.0/attendance1.png', 'See who is attending the game')}
                {createThumbnail('/v1.8.0/attendance2.png', 'Send messages to all members of the venue')}
              </div>
            </div>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.7.0</h3>
                <span className="text-sm text-gray-400">21st October 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">Only one update for this version, but it's significant enough to warrant its own release!</h4>
            <p className="text-gray-300 mb-4">Here's what's new:</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              {createClickableListItem('Added summary card on venue front page displaying top three players for last month\'s statistics', '/v1.7.0/league1.jpg')}
              {createClickableListItem('See stats by month, quarter, or year', '/v1.7.0/league2.jpg')}
              {createClickableListItem('Drill down to see detailed individual player statistics', '/v1.7.0/league3.jpg')}
            </ul>
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.7.0/league1.jpg', 'Detailed league tables based on weekly game reports feature preview')}
                {createThumbnail('/v1.7.0/league2.jpg', 'Detailed league tables based on weekly game reports feature preview')}
                {createThumbnail('/v1.7.0/league3.jpg', 'Detailed league tables based on weekly game reports feature preview')}
              </div>
            </div>
            <p className="text-gray-300 mb-4">Substantial effort went into this release, you asked for it…. we delivered!</p>
            <p className="text-gray-300 mb-4">Automatic league tables now generated from your regular weekly game reports. Simply fill out the game report at the end of each game, and monthly, quarterly, and annual reports will provide in-depth insights into your venue's games.</p>
            <p className="text-gray-300 mb-4">A summary card on your venue's front page displays the top three players for the last month's statistics. From there, you can access the full report and explore each registered user's statistics, including their placement in each game and their prizes. All of this is free; the admin just needs to complete a game report each week—simple but effective! We think you'll agree!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.6.4</h3>
                <span className="text-sm text-gray-400">15th October 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">The features keep coming!</h4>
            <p className="text-gray-300 mb-4">Looking back at version 1.0.0, we were thrilled with our achievements. Since then, we've added over 50 new features and enhancements, which have amazed us. We especially enjoy incorporating your requests. Remember, the main USP of Poppy Poker is the ability to alert all connected devices simultaneously about any level changes; everything else is a bonus - nobody else has achieved this as well as we have, it was a hard nut to crack but we cracked it, we're leading the way!</p>
            <p className="text-gray-300 mb-4">Here are a few highlights from the latest version:</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              {createClickableListItem('Added forgotten password functionality for manual logins', '/v1.6.4/forgotPassword.jpg')}
              <li>• Reworked app upgrade message mechanism</li>
              {createClickableListItem('Added link to Venue from the game detail page', '/v1.6.4/linkToVenue.jpg')}
              <li>• Improved several layouts</li>
              <li>• Removed the test inn from the list of venues</li>
            </ul>
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.6.4/forgotPassword.jpg', 'Forgotten password functionality for manual logins feature preview')}
                {createThumbnail('/v1.6.4/linkToVenue.jpg', 'Link to Venue from the game detail page feature preview')}
              </div>
            </div>
            <p className="text-purple-400 font-medium">We can't thank you enough—keep the feedback coming, whether good or bad. It only makes Poppy Poker better!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.6.3</h3>
                <span className="text-sm text-gray-400">1st October 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">Performance optimization and fine-tuning!</h4>
            <p className="text-gray-300 mb-4">We're seeing quite heavy usage on our back end engine that coordinates all game timers, we thought it vitally important we focus on performance for this aspect of the application so we reviewed the algorithms that deliver timing updates and notification to all your devices! This was the main focus on this latest release, we didn't think we could squeeze any more performance out of our Java engine but we were wrong, she's been fine tuned now - to perfection!!</p>
            <p className="text-gray-300 mb-4">We also managed to squeeze some more improvements into this version that we hope you will enjoy:</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              <li>• Improved performance for message sending</li>
              <li>• New user preference capabilities added</li>
              <li>• New refresh button on Venues page if error fetching venues</li>
              <li>• Notifications not sent if device is in low power mode</li>
            </ul>
            <p className="text-purple-400 font-medium">Keep the feedback coming team!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.6.1</h3>
                <span className="text-sm text-gray-400">18th September 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">We're excited to incorporate your thoughts and ideas!</h4>
            <p className="text-gray-300 mb-4">One aspect we overlooked while developing the app was 'low power mode.' It disrupts our notification platform. We addressed the issue and released a fix in under a week, demonstrating our agility in engaging with the Poppy Poker community.</p>
            <p className="text-gray-300 mb-4">Another great feature in this release is the "game audit log for admin users." You can now view a complete chronological audit of events. Press the 'Add one minute' button, and all changes are logged, making it easy to track any accidental clock or game adjustments.</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              {createClickableListItem('Low power mode detection - no more false/missed alerts', '/v1.6.1/lowPowerMode1.jpg')}
              {createClickableListItem('Game audit log for admin users', '/v1.6.1/gameLog.jpg')}
              {createClickableListItem('Game connection stats for admin users, available from game screen', '/v1.6.1/connectionStats.jpg')}
              <li>• Backend retry mechanism if client requests fail</li>
            </ul>
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.6.1/lowPowerMode1.jpg', 'Low power mode detection - no more false/missed alerts feature preview')}
                {createThumbnail('/v1.6.1/lowPowerMode2.jpg', 'Low power mode detection - no more false/missed alerts feature preview')}
                {createThumbnail('/v1.6.1/gameLog.jpg', 'Game audit log for admin users feature preview')}
                {createThumbnail('/v1.6.1/connectionStats.jpg', 'Game connection stats for admin users, available from game screen feature preview')}
              </div>
            </div>
            <p className="text-purple-400 font-medium">Thank you for your feedback and helping us improve Poppy Poker!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.6.0</h3>
                <span className="text-sm text-gray-400">29th August 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">You'll love this addition!</h4>
            <p className="text-gray-300 mb-4">We all love a little break during a game, everyone pops off to do their own thing during a break. Now when an admin user restated the game they get the option to "Notify all players that the game has restarted!". Everyone that has Poppy Poker installed then receives an audio notification informing them the game has restarted! A cool feature that nobody else has mastered yet!</p>
            <p className="text-gray-300 mb-4">Here's a list of new features you may like:</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              {createClickableListItem('Added game restart audio broadcast when game resumes after breaks', '/v1.6.0/restartNotificaton.jpg')}
              {createClickableListItem('Added a version check popup', '/v1.6.0/appUpgrade.png')}
              <li>• Removed unwanted components</li>
              <li>• Changed email provider for faster email delivery!</li>
            </ul>
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.6.0/appUpgrade.png', 'Version check popup feature preview')}
                {createThumbnail('/v1.6.0/restartNotificaton.jpg', 'Game restart audio broadcast when game resumes after breaks feature preview')}
              </div>
            </div>
            <p className="text-purple-400 font-medium">Try out these new features and let us know what you think (by using the new feedback feature 😜)</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.5.0</h3>
                <span className="text-sm text-gray-400">5th August 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">We've included an easier way for you to get in touch with us!</h4>
            <p className="text-gray-300 mb-4">We adore your comments and suggestions so thought it only right to include a better way for you to get in touch! You can now supply your feedback via the in-game menu button at the bottom right of the screen!</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              {createClickableListItem('Users can now send feedback when in a game', '/v1.5.0/feedback.jpg')}
              <li>• Added map link to clubs to display club location</li>
              <li>• General performance improvements</li>
            </ul>
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.5.0/feedback.jpg', 'Users can now send feedback when in a game feature preview')}
              </div>
            </div>
            <p className="text-purple-400 font-medium">Try out the new features and give us your all-important feedback!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.4.0</h3>
                <span className="text-sm text-gray-400">29th June 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">A fresh new look!</h4>
            <p className="text-gray-300 mb-4">We thought it was time for a revamp and you guys deserve a more pleasing on-the-eye experience so we've spent a lot of time on a new stylish look and feel to the app!</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              {createClickableListItem('Major frontend refresh, more stylish look for the main game screen', '/v1.4.0/newLayout.jpg')}
            </ul>
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.4.0/newLayout.jpg', 'Major frontend refresh, more stylish look for the main game screen feature preview')}
              </div>
            </div>
            <p className="text-purple-400 font-medium">Take her for a spin and let us know what you think of the new look!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.3.0</h3>
                <span className="text-sm text-gray-400">8th June 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">New Tools and Club Content!</h4>
            <p className="text-gray-300 mb-4">We've rolled out a whole new tools menu option where we will add a list of useful tools that make your life easier.</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              {createClickableListItem('Added club content management component', '/v1.3.0/content.jpg')}
              {createClickableListItem('Added new tools section', '/v1.3.0/tools.jpg')}
              {createClickableListItem('Pot Split calculator', '/v1.3.0/calculator.jpg')}
              <li>• Bug fix: Fixed photo upload issue</li>
            </ul>
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.3.0/content.jpg', 'Club content management component feature preview')}
                {createThumbnail('/v1.3.0/tools.jpg', 'Pot Split utility feature preview')}
                {createThumbnail('/v1.3.0/calculator.jpg', 'Pot Split calculator feature preview')}
              </div>
            </div>
            <p className="text-purple-400 font-medium">Thanks for all your support, we're building this together!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.2.0</h3>
                <span className="text-sm text-gray-400">3rd June 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">Big Feature Update!</h4>
            <p className="text-gray-300 mb-4">We're on a roll! We're loving the community's feedback, it really spurs us on! This release brings lots of new exciting features.</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              {createClickableListItem('Users can change their display name', '/v1.2.0/changeDisplayName.png')}
              {createClickableListItem('New game photo album', '/v1.2.0/gamePhotoAlubm.png')}
              {createClickableListItem('New photo capture during games', '/v1.2.0/photoGallery.jpg')}
              {createClickableListItem('Capture and display game winner photo', '/v1.2.0/winner.jpg')}
              {createClickableListItem('New blind structure overhaul to add breaks', '/v1.2.0/breaks.jpg')}
              {createClickableListItem('Improved in-game menu options', '/v1.2.0/ingamemenu.jpg')}
            </ul>

            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.2.0/changeDisplayName.png', 'Change display name feature preview')}
                {createThumbnail('/v1.2.0/gamePhotoAlubm.png', 'Game photo album feature preview')}
                {createThumbnail('/v1.2.0/photoGallery.jpg', 'Photo capture during games feature preview')}
                {createThumbnail('/v1.2.0/winner.jpg', 'Game winner photo feature preview', 'The cat that got the cream!')}
                {createThumbnail('/v1.2.0/breaks.jpg', 'New blind structure overhaul to add breaks feature preview')}
                {createThumbnail('/v1.2.0/ingamemenu.jpg', 'In-game menu options feature preview')}
              </div>
            </div>

            <p className="text-purple-400 font-medium">Thanks for the positive feedback, keep it coming!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.1.0</h3>
                <span className="text-sm text-gray-400">31st January 2025</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">Refinements and Enhancements</h4>
            <p className="text-gray-300 mb-4">We couldn't believe how well version 1 was received! This release focuses on performance improvements and player experience.</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              <li>• Minimised websocket traffic</li>
              {createClickableListItem('Now cater for game breaks', '/v1.1.0/break.png')}
              <li>• Fixed bug with paused game</li>
              <li>• Increased GPS game finder from 50 miles to 200 miles</li>
            </ul>
            
            {/* Break Feature Thumbnail */}
            <div className="mb-4">
              <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
              <div className="flex flex-wrap gap-4">
                {createThumbnail('/v1.1.0/break.png', 'Game breaks feature preview')}
              </div>
            </div>
            
            <p className="text-purple-400 font-medium">If you have an idea, send us a message!</p>
          </div>

          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              <img src="/images/chip.png" alt="Chip" className="w-8 h-8 mr-3 opacity-80" />
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                <h3 className="text-2xl font-semibold text-purple-400">v1.0.0</h3>
                <span className="text-sm text-gray-400">14th January 2024</span>
              </div>
            </div>
            <h4 className="text-lg font-medium text-white mb-3">Initial Release - The Beginning of Something Amazing!</h4>
            <p className="text-gray-300 mb-4">We are thrilled to announce Poppy Poker (v1.0.0) is now available on the App Store and Play Store.</p>
            <p className="text-gray-300 mb-4">Poppy Poker's unique selling point is its simultaneous alert feature for all connected devices, ensuring you never miss a level change. Here's a quick summary of other amazing features available:</p>
            <ul className="text-gray-400 space-y-2 mb-4">
              <li>• <strong>Main game screen synchronisation</strong> - Synchronised critical game data across all devices — no one else can match our capability!</li>
                <li>• <strong>Receive level change alerts simultaneously on all devices - <span className="font-bold text-yellow-400">this is a game changer!</span></strong></li>
              <li>• <strong>Club summary page</strong>
                <ul className="ml-4 mt-1 space-y-1">
                  <li>• <strong>Upcoming games</strong></li>
                  <li>• <strong>Completed game reports</strong> - Detailed reports of winners</li>
                </ul>
              </li>
              <li>• <strong>Access all reports from the venue summary page</strong></li>
              <li>• <strong>Feedback from registered players</strong></li>
              <li>• <strong>Find nearby games</strong> - Use GPS to locate nearby and upcoming games!</li>
              <li>• <strong>One-click access to critical game info</strong></li>
              <li>• <strong>Filter games by distance</strong></li>
              <li>• <strong>Separate sections for running and upcoming games</strong></li>
              <li>• <strong>User registration</strong> - Quick registration with Apple or Google login</li>
              <li>• <strong>Venue registration</strong> - Enter your zip/postcode for GPS searchable games!</li>
              <li>• <strong>Define your own blind structure</strong> - incorporate breaks to your game!</li>
              <li>• <strong>Three game types:</strong>
                <ul className="ml-4 mt-1 space-y-1">
                  <li>• Instant: Start immediately</li>
                  <li>• Weekly: Schedule regular games</li>
                  <li>• Scheduled: Plan a one-off game</li>
                </ul>
              </li>
            </ul>
            <p className="text-purple-400 font-medium">This is just the beginning! We will keep adding features based on your feedback. Share your requests, and your ideas may be included in future updates!</p>
          </div>
        </div>
      </div>
      
      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-2"
          onClick={closeModal}
        >
          <div className="relative w-full h-full flex items-center justify-center">
            <img 
              src={selectedImage} 
              alt="Full size preview" 
              className="max-w-full max-h-full w-auto h-auto object-contain"
              style={{ maxWidth: '100vw', maxHeight: '100vh' }}
            />
            <button 
              onClick={closeModal}
              className="absolute top-4 right-4 text-white hover:text-gray-300 text-3xl font-bold bg-black/70 rounded-full w-10 h-10 flex items-center justify-center hover:bg-black/90 transition-colors"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
